import { render } from "./ImportsModal.vue?vue&type=template&id=420701c2&ts=true"
import script from "./ImportsModal.vue?vue&type=script&lang=ts"
export * from "./ImportsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__